import { Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/custom-hooks/redux/redux";
import { AUTHORIZATIONS } from "src/utils/constants/authorization-constants";

const NoPendingMailsLink = () => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const isRecipient = currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.isRecipient);

  const isOnlyRecipient =
    (!currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadIncoming) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming)) ??
    true;

  return (
    <Grid
      style={{
        color: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography variant="h5">
        {isRecipient && isOnlyRecipient
          ? `${t(`${tRP}.no_incoming_mails`)}`
          : isRecipient && !isOnlyRecipient
          ? `${t(`${tRP}.no_received_no_pending_mails`)}`
          : !isRecipient && `${t(`${tRP}.no_pending_mail`)}`}
      </Typography>
      <Typography style={{ alignSelf: "end" }}>{`${t(`${tRP}.see_all`)}`}</Typography>
    </Grid>
  );
};

export default NoPendingMailsLink;
